<template>
  <a-select
    :disabled="disabled"
    :multiple="false"
    :placeholder="placeholder"
    :value="value"
    allow-clear
    option-filter-prop="title"
    show-search
    @change="onChange"
  >
    <a-select-option v-for="item in records" :key="item.id" :title="item.name" :value="item.id">
      {{ item.name }}
    </a-select-option>
  </a-select>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, PropType } from "vue";
import { ProfileService } from "@/views/maintenance/project/project.service";
import {
  ProfileSimpleListReq,
  ProfileSimpleRecord,
} from "@/views/maintenance/project/project.interface";
import { onMountedOrActivated } from "@/core/hooks/onMountedOrActivated";
/**
 * 维保项目选择器
 *
 * 使用方式:
 * <maintenance-project-select v-model:value="formRef.projectId"></maintenance-project-select>
 */
export default defineComponent({
  isGlobal: true,
  name: "MaintenanceProjectSelect",
  props: {
    value: {
      type: String,
      default: undefined,
    },
    externalData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },

    placeholder: {
      type: String,
      default: "请选择",
    },

    // 其他状态
    // 技术方案: skillSolutionValidStatus
    // 招标申请: bidValidStatus
    // 招标文件购买申请: bidFileApplyValidStatus
    // 保证金申请: assuringMoneyApplyProcessStatus
    // 招标报价: bidOfferValidStatus
    /**
     * 可能后续不会用到
     */
    otherStatus: {
      type: Array,
      default: () => [],
    },

    // 项目状态, 从字典中获取, 字典值: project_status
    projectStatus: {
      type: Array,
      default: () => [],
    },
    flowStatus: {
      type: Array,
      default: () => [],
    },
    api: {
      type: String,
    },
    defaultItem: {
      type: Array as PropType<ProfileSimpleRecord[]>,
      default: () => [],
    },
    req: {
      type: Object,
      default: () => {},
    },
    isBackName: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:value", "change"],
  setup(props, { emit }) {
    let { data: records, run, loading } = ProfileService.useSimpleListApi();
    const onChange = async (id) => {
      emit("update:value", id);
      if (id) {
        let select = records?.value.find((v) => (v as any).id == id);
        // console.log(select, "selct");
        emit("change", select);
      }
    };

    onMountedOrActivated(async () => {
      const req = new ProfileSimpleListReq();
      // console.log("cndy");
      req.merge({
        flowStatus: props.flowStatus[0],
      });
      req.merge(props.req);
      await run(req, props.api);
      let array: any = JSON.parse(JSON.stringify(records.value));
      props.defaultItem.forEach((item) => {
        if (!array.find((value) => value.id == item.id)) {
          array.push(item);
        }
      });
      //编辑技术方案时，回显使用
      if (props.externalData.projectId && props.externalData.projectName) {
        array.push({ id: props.externalData.projectId, name: props.externalData.projectName });
      }
      records.value = array;
    });

    return {
      records,
      loading,
      onChange,
    };
  },
});
</script>
